// MF-67 — Category visibility matrix (Graphs / Summary × Student / Parent / Staff) as a small, clearly
// labelled grid of toggles. `readOnly` renders ticks for previews. Value: { graph: {student,parent,staff},
// summary: {…} }.
import { Checkbox } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const AUDIENCES = [
  { key: 'student', label: 'Students' },
  { key: 'parent', label: 'Parents' },
  { key: 'staff', label: 'Staff' }
]
const SURFACES = [
  { key: 'graph', label: 'Graphs' },
  { key: 'summary', label: 'Summary' }
]

export const audiencesLabel = (o = {}) =>
  AUDIENCES.filter((a) => o?.[a.key])
    .map((a) => a.label)
    .join(', ') || 'Nobody'

const cell = { padding: '10px 12px', borderBottom: '1px solid rgb(241, 245, 249)', textAlign: 'center' }

const VisibilityMatrix = ({ value = {}, onChange, readOnly = false }) => (
  <div
    style={{
      border: '1px solid rgb(226, 232, 240)',
      borderRadius: 10,
      overflow: 'hidden',
      background: '#fff'
    }}
  >
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
      <thead>
        <tr style={{ background: 'rgb(248, 250, 252)' }}>
          <th
            style={{
              ...cell,
              textAlign: 'left',
              fontSize: 12,
              fontWeight: 600,
              color: 'rgb(71, 85, 105)'
            }}
          />
          {AUDIENCES.map((a) => (
            <th key={a.key} style={{ ...cell, fontSize: 12, fontWeight: 600, color: 'rgb(71, 85, 105)' }}>
              {a.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {SURFACES.map((s, i) => (
          <tr key={s.key}>
            <td
              style={{
                ...cell,
                textAlign: 'left',
                ...(i === SURFACES.length - 1 ? { borderBottom: 'none' } : {})
              }}
            >
              <div style={{ fontWeight: 500, color: 'rgb(15, 23, 42)' }}>{s.label}</div>
            </td>
            {AUDIENCES.map((a) => {
              const on = Boolean(value?.[s.key]?.[a.key])
              return (
                <td
                  key={a.key}
                  style={{ ...cell, ...(i === SURFACES.length - 1 ? { borderBottom: 'none' } : {}) }}
                >
                  {readOnly ? (
                    on ? (
                      <FontAwesomeIcon icon={['fal', 'check']} style={{ color: 'rgb(22, 163, 74)' }} />
                    ) : (
                      <span style={{ color: 'rgb(203, 213, 225)' }}>—</span>
                    )
                  ) : (
                    <Checkbox
                      size='small'
                      checked={on}
                      inputProps={{ 'aria-label': `${s.label} visible to ${a.label}` }}
                      onChange={() =>
                        onChange?.({
                          ...value,
                          [s.key]: { ...(value?.[s.key] || {}), [a.key]: !on }
                        })
                      }
                    />
                  )}
                </td>
              )
            })}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default VisibilityMatrix
